import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { API_ENDPOINTS, fetchFromApi } from '../config/api';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import '../styles/ReleasesPage.css';

const ReleasesPage = () => {
  const [releases, setReleases] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchReleases = async () => {
      try {
        setLoading(true);
        // Fetch all releases with limit=100
        const data = await fetchFromApi(`${API_ENDPOINTS.releases}?limit=100`, {
          method: 'GET',
          mode: 'cors'
        });

        if (!data || data.error) {
          console.error('Error fetching releases:', data?.error);
          setError('Failed to load releases');
          setReleases([]);
          return;
        }

        const transformedReleases = data.map(release => ({
          id: release.id,
          title: release.title,
          artist: release.artist,
          releaseDate: release.release_date,
          label: release.label || 'Independent',
          genres: release.genres || [],
          // Handle tracklist stored as { tracks: [...] } or direct array
          tracklist: Array.isArray(release.tracklist) 
            ? release.tracklist 
            : (release.tracklist?.tracks || []),
          links: release.links || {},
          artwork: release.artwork_url || '/images/releases/release-placeholder.png'
        }));

        console.log('Fetched releases:', transformedReleases);
        setReleases(transformedReleases);
        setError(null);
      } catch (err) {
        console.error('Error fetching releases:', err);
        setError('Failed to load releases');
        setReleases([]);
      } finally {
        setLoading(false);
      }
    };

    fetchReleases();
  }, []);


  return (
    <>
      <Helmet>
        <title>Releases | The Lost Loft</title>
        <meta name="description" content="Discover music releases from The Lost Loft artists. Original productions and collaborations in Chicago underground house and techno." />
        <link rel="canonical" href="https://thelostloft.com/releases" />
        <meta property="og:title" content="Releases | The Lost Loft" />
        <meta property="og:description" content="Discover music releases from The Lost Loft artists. Original productions and collaborations in Chicago underground house and techno." />
        <meta property="og:url" content="https://thelostloft.com/releases" />
      </Helmet>
      <Navbar />
      <main className="releases-page">
        <div className="releases-container">
          <h1>Releases</h1>
          {loading ? (
            <div className="loading">Loading releases...</div>
          ) : error ? (
            <div className="error-message">{error}</div>
          ) : releases.length === 0 ? (
            <div className="no-releases-message">No releases available at this time.</div>
          ) : (
            <div className="releases-gallery">
              {releases.map((release, index) => (
                <a 
                  key={`release-${release.id || index}`} 
                  className="release-tile"
                  href={release.links?.bandcamp || '#'}
                  target="_blank"
                  rel="noopener noreferrer"
                  title={`${release.artist} - ${release.title}`}
                >
                  <div className="release-artwork">
                    <img 
                      src={release.artwork} 
                      alt={`${release.title} by ${release.artist}`} 
                      loading="lazy" 
                    />
                    <div className="release-overlay">
                      <span className="release-title">{release.title}</span>
                      <span className="release-artist">{release.artist}</span>
                    </div>
                  </div>
                </a>
              ))}
            </div>
          )}
        </div>
      </main>
      <Footer />
    </>
  );
};

export default ReleasesPage;
